import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {UrlConstants} from '../../../shared/url.constant';
import {AbstractControl, FormBuilder, FormGroup} from '@angular/forms';
import {AdminService} from '../../../shared/admin.services';
import {Router} from '@angular/router';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import {ConstantUtils} from '../../../utils/constant.utils';
import {CommonUtil} from '../../../utils/common.util';
import * as printJS from 'print-js';


@Component({
  selector: 'history-export',
  templateUrl: './history-export.component.html',
  styleUrls: ['./history-export.component.scss']
})
export class HistoryExportComponent implements OnInit {

  public summaryClicked = false;
  public summarised = false;

  public summaryExportClicked = false;
  public summaryExported = false;

  public summaryPrintClicked = false;
  public summaryPrinted = false;

  public summary;
  public notPaidsummary;
  public summaryParams;

  public fileType = 'csv';
  public exportData = [];
  public showloader = false;
  fileUrl;
  @Input() summaryQueryParams;
  @Input() currentMenuPage;

  public unpaid = false;

  public summarisedFromDate;
  public summarisedToDate;

  public placeholderPath = '../../../../../assets/images/iv_logo.png';
  schoolName;
  schoolAddressLine1;
  schoolAddressLine2;
  public logoName;
  public imageUrl;
  public schoolNameForm: FormGroup;
  public schoolNameInput: AbstractControl;

  printReq;
  printObj = [];

  todayDate;

  constructor(public fb: FormBuilder, private adminService: AdminService, private router: Router) {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();

    this.todayDate = day + '-' + month + '-' + year;

  }

  onSummary() {
    this.summaryClicked = true;
    this.summarised = false;

    if (this.summaryQueryParams.includes('payment_status=unpaid')) {

      this.unpaid = true;

      console.log(this.currentMenuPage, 'this.currentMenuPage');
      if (this.currentMenuPage === 'cancel') {
        if (this.summaryQueryParams.includes('&payment_status=')) {
          if (this.summaryQueryParams.includes('&payment_status=all')) {
            this.summaryQueryParams = this.summaryQueryParams.replace(/&payment_status=all/g, '&payment_status=cancelled');
          } else if (this.summaryQueryParams.includes('&payment_status=paid')) {
            this.summaryQueryParams = this.summaryQueryParams.replace(/&payment_status=paid/g, '&payment_status=cancelled');
          } else {
            this.summaryQueryParams = this.summaryQueryParams.replace(/&payment_status=partial/g, '&payment_status=cancelled');
          }
        }
      }
      console.log(this.fileType, '');
      const params = this.summaryQueryParams + '&type=' + this.fileType;


      const unpaidurl = UrlConstants.getFeePaymentHistoryForUnpaid + '?' + params;

      this.adminService.get({url: unpaidurl, params: ''}).then(async res => {
        if (res.success && res.data && res.data.total_count > 0) {
          const unPaidPaymentHistory = res.data.items;

          if (res.success === true) {
            this.summarised = true;
            const sum = unPaidPaymentHistory.reduce((acc, cur) => acc + (cur['due_amount'] || 0), 0);

            this.notPaidsummary = {
              'student_count' : unPaidPaymentHistory.length,
              'total_amount_paid' : sum
            };

            // this.summary.total_amount_paid = sum;
          } else {
            this.summarised = false;
          }
          (<any>$('#not-paid-payment-history-summary')).modal({backdrop: 'static', keyboard: false});
          (<any>$('#not-paid-payment-history-summary')).modal('show');

          this.summaryClicked = false;
        }
      }).catch((error) => {
        console.log(error);
        this.summarised = false;
        this.summaryClicked = false;
        (<any>$('#not-paid-payment-history-summary')).modal({backdrop: 'static', keyboard: false});
        (<any>$('#not-paid-payment-history-summary')).modal('show');
      });

    } else {

      this.unpaid = false;

      //https://run.mocky.io/v3/84f30ef0-7e06-4a03-8730-b74ce1d286b5
      const fromDate = this.summaryQueryParams.split('from=').pop().split('&')[0];
      const toDate = this.summaryQueryParams.split('to=').pop().split('&')[0];
      const academicFeeId = this.summaryQueryParams.split('academic_fee_id=').pop().split('&')[0];
      const fixedFeeId = this.summaryQueryParams.split('fixed_fee_id=').pop().split('&')[0];
      const specialFeeId = this.summaryQueryParams.split('special_fee_id=').pop().split('&')[0];
      const classId = this.summaryQueryParams.split('class_id=').pop().split('&')[0];
      const sectionId = this.summaryQueryParams.split('section_id=').pop().split('&')[0];


      this.summaryParams = '?from_date=' + moment(fromDate).format('YYYY-MM-DD')
                          + '&to_date=' + moment(toDate).format('YYYY-MM-DD')
                          + '&academic_fee_id=' + academicFeeId
                          + '&fixed_fee_id=' + fixedFeeId
                          + '&special_fee_id=' + specialFeeId
                          + '&class_id=' + classId
                          + '&section_id=' + sectionId;
      this.summarisedFromDate = moment(fromDate).format('DD-MM-YYYY')
      this.summarisedToDate = moment(toDate).format('DD-MM-YYYY');
      this.adminService.get({url: UrlConstants.getPaymentSummaryNew, params: this.summaryParams})
        .then(res => {
          if (res.success === true) {
            this.summarised = true;
            this.summary = res.data;
          } else {
            this.summarised = false;
          }
          (<any>$('#payment-history-summary-new')).modal('show');
          (<any>$('#payment-history-summary-new')).modal({backdrop: 'static', keyboard: false});

          this.summaryClicked = false;
        }).catch((err) => {
        console.log(err);
        this.summarised = false;
        this.summaryClicked = false;
        (<any>$('#payment-history-summary-new')).modal({backdrop: 'static', keyboard: false});
        (<any>$('#payment-history-summary-new')).modal('show');
      });
    }
  }

  schoolData() {
    let bootstrapData;
    if (localStorage[ConstantUtils.BOOTSTRAP]) {
      bootstrapData = JSON.parse(localStorage[ConstantUtils.BOOTSTRAP]);
    } else {
      bootstrapData = CommonUtil.getBootstrapData();
    }

    const schoolData = bootstrapData['school'];
    this.schoolName = schoolData['school_name'];
    this.logoName = schoolData['logo_name'];
    this.imageUrl = UrlConstants.getImage + '?thumbnail=false&image=' + this.logoName;
    // this.schoolNameInput.setValue(this.schoolName);
    let doorNo, street, area, city, state, pincode;

    doorNo = schoolData['door_no'] ? schoolData['door_no'] + ', ' : ' ';
    street = schoolData['street'] ? schoolData['street'] + ', ' : ' ';
    area = schoolData['area'] ? schoolData['area'] + ', ' : ' ';
    city = schoolData['city'] ? schoolData['city'] + ', ' : ' ';
    state = schoolData['state'] ? schoolData['state'] + ' - ' : ' ';
    pincode = schoolData['pincode'] ? schoolData['pincode'] : ' ';

    this.schoolAddressLine1 = doorNo + street;
    this.schoolAddressLine2 = area + city + state + pincode;

    console.log('this.imageUrl >>>>  ' + this.imageUrl);
  }

  // public exportMapObj = {
  //   from_date: 'from_date',
  //   to_date: 'to_date',
  //   academic_fee_id: 'class',
  //   fixed_fee_id: 'section',
  //   special_fee_id: 'section',
  //   class_id: 'section',
  //   section_id: 'section'
  // };
  //
  // public formQueryString(obj) {
  //   let queryStr = '';
  //   const _this = this;
  //   Object.keys(obj).forEach(function (key) {
  //     const qStr = (obj[key]) ? _this.exportMapObj[key] + '=' + obj[key] : '';
  //     queryStr += (queryStr != '') ? (qStr != '') ? '&' + qStr : '' : qStr;
  //   });
  //   return queryStr;
  // }

  async onExport() {
    //At this point limit and page parma are send but not used in backend - Need to remove in future 02-07-20
    // this.showloader = true
    console.log(this.currentMenuPage, 'this.currentMenuPage');
    if (this.currentMenuPage === 'cancel') {
      if (this.summaryQueryParams.includes('&payment_status=')) {
        if (this.summaryQueryParams.includes('&payment_status=all')) {
          this.summaryQueryParams = this.summaryQueryParams.replace(/&payment_status=all/g, '&payment_status=cancelled');
        } else if (this.summaryQueryParams.includes('&payment_status=paid')) {
          this.summaryQueryParams = this.summaryQueryParams.replace(/&payment_status=paid/g, '&payment_status=cancelled');
        } else {
          this.summaryQueryParams = this.summaryQueryParams.replace(/&payment_status=partial/g, '&payment_status=cancelled');
        }
      }
    }
    console.log(this.fileType, '');
    const params = this.summaryQueryParams + '&type=' + this.fileType;

    let url;
    if (this.summaryQueryParams.includes('payment_status=unpaid')) {
      url = UrlConstants.getFeePaymentHistoryForUnpaid + '?' + params;

      this.adminService.get({url: url, params: ''}).then(async res => {
        if (res.success && res.data && res.data.total_count > 0) {
          const unPaidPaymentHistory = res.data.items;
          this.downloadFile(unPaidPaymentHistory);
        }
      }).catch((error) => {
        console.log(error, 'in catch');
        this.showloader = false;
      });

    } else {
      url = UrlConstants.paymentHistoryExport + '?' + params;
      this.adminService.postCsvDownload({url, params}).subscribe((data) => {
        const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `exported.csv`;
        link.click();
      });
    }
  }

  exportSummary() {

    this.summaryExportClicked = true;
    this.summaryExported = false;

    this.adminService.get({url: UrlConstants.getPaymentSummaryNew, params: this.summaryParams}).then(res => {
        if (res.success && res.data) {
          this.summaryExported = true;
          let summaryDataForExport;

          summaryDataForExport = {
            'classReport' : res.data.classReport,
            'feeReport': res.data.feeReport,
            'PaymentModeReport': res.data.PaymentModeReport
          };
          // this.exportAsExcelFile(summaryDataForExport, 'summary');
        } else {
          this.summaryExported = false;
        }
      this.summaryExportClicked = false;
      }).catch((error) => {
        console.log(error, 'in catch');
        this.showloader = false;
      this.summaryExportClicked = false;
      });
  }

  downloadFile(data: any) {
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = 'exported.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }


  export_xls(element) {
    let tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

    tab_text = tab_text + '<x:Name>Summary</x:Name>';

    tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';

    tab_text = tab_text + '<table border=\'100px\'>';
    tab_text = tab_text + document.getElementById(element).innerHTML;
    tab_text = tab_text + '</table></body></html>';

    const data_type = 'data:application/vnd.ms-excel';

    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      if (window.navigator.msSaveBlob) {
        const blob = new Blob([tab_text], {
          type: 'application/csv;charset=utf-8;'
        });
        navigator.msSaveBlob(blob, 'summary.xls');
      }
    } else {
      const downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.href = data_type + ', ' + encodeURIComponent(tab_text);
      downloadLink.download = 'summary.xls';
      downloadLink.click();
    }
  }

  async downloadSummaryPDF() {
    this.summaryPrintClicked = true;
    this.summaryPrinted = false;

    this.showloader = true;
    this.printObj = [{
      school_logo: this.imageUrl,
      school_name: this.schoolName,
      school_address: this.schoolAddressLine1 + this.schoolAddressLine2,
      current_date: this.todayDate,
      from_date: this.summarisedFromDate,
      to_date: this.summarisedToDate,
      classReport: this.summary.classReport,
      feeReport: this.summary.feeReport,
      PaymentModeReport: this.summary.PaymentModeReport
    }];
    this.printReq = {
      print: true,
      template_name: 'fees_collection_sumarry',
      array: this.printObj
    };

    // console.log('print req', this.printReq);
    // return ;
    try {
      const reqUrl = UrlConstants.downloadPdf;
      (<any>$('#print-preview-modal')).modal('hide');
      this.adminService.printReportCard({url: reqUrl, params: this.printReq}).subscribe(data => {
        this.showloader = false;
        if (data) {
          this.summaryPrinted = true;
          if (this.printReq.print) {
            const blob = new Blob([data], {type: 'application/pdf'});
            const pdfURL = window.URL.createObjectURL(blob);
            printJS(pdfURL);
            console.log('Print ## ', data);
          } else {
            const blob = new Blob([data], {type: 'application/pdf'});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.printReq.template_name}_` + this.printObj[0].student.register_number + `.pdf`;
            link.click();
          }
        } else {
          this.summaryPrinted = false;
          console.log('Error on Print/Download Form.');
        }

        this.summaryPrintClicked = false;
      });
    } catch (err) {
      this.summaryPrintClicked = false;
      this.showloader = false;
      console.log('Error on Print/Download Form.' + err.message);
      return err.response.data;
    }
  }

  getValue(type) {
    this.fileType = type;
  }


  ngOnInit() {
    this.schoolData();
  }

}
